<template>
	<div
		id="wrapper"
		class="not-found"
		:class="{ pointer: homePath }"
		@click="goHome"
	>
		<div class="not-found-holder">
			<span class="not-found-title">THIS PAGE IS LOST</span>
			<span class="not-found-subtitle"
				>The page you're looking for isn't available.</span
			>
			<div v-if="homePath" class="button">
				Go Home
			</div>
			<img
				class="not-found-image"
				src="../assets/images/placeholder_404.svg"
				alt=""
			/>
		</div>
	</div>
</template>

<script>
import storage from '@/utils/storage'

export default {
	name: 'NotFound',

	data: () => ({
		homePath: null
	}),

	mounted() {
		const venueChain = storage.getStorage('lastVenueChainSubdomain')
		const venueId = storage.getStorage('lastVenueId')

		if (venueChain && venueId) {
			this.homePath = { path: `/${venueChain}/${venueId}` }
		}
	},

	methods: {
		goHome() {
			if (!this.homePath) return

			this.$router.push(this.homePath)
		}
	}
}
</script>

<style lang="scss">
.qr-data {
	white-space: normal;
}
#wrapper.not-found {
	display: block;
	padding: 24px;
	overflow-x: hidden;
	-webkit-overflow-scrolling: touch;
	white-space: nowrap;
	text-align: center;
	color: #fff;

	&.pointer {
		cursor: pointer;
	}

	&:after {
		display: inline-block;
		vertical-align: middle;
		height: 100%;
		width: 0;
		content: '';
	}
}

.not-found-holder {
	display: inline-block;
	vertical-align: middle;
}

.not-found-title {
	display: block;
	padding: 0 0 12px;
	font-size: 24px;
	font-weight: 800;
}

.not-found-subtitle {
	display: block;
	padding: 0 0 24px;
	font-size: 12px;
}

.not-found-image {
	display: block;
	margin: 0 auto;
	max-width: 100%;
	height: auto;
}

@media (max-width: 767px) {
	#wrapper.not-found {
		padding: 8px;
	}
}
</style>
